var map = {
	"./activity-color.svg": 61839,
	"./activity-gray.svg": 63984,
	"./bank-color.svg": 90397,
	"./bank-gray.svg": 13863,
	"./calendar-color.svg": 86250,
	"./calendar-gray.svg": 31126,
	"./call-forwarding-color.svg": 67019,
	"./call-forwarding-gray.svg": 53444,
	"./campaign-report-color.svg": 79255,
	"./campaign-report-gray.svg": 69406,
	"./campaigns-color.svg": 81437,
	"./campaigns-gray.svg": 21273,
	"./checkboxes-color.svg": 77238,
	"./checkboxes-gray.svg": 26184,
	"./combine-contact-sources-color.svg": 45697,
	"./combine-contact-sources-gray.svg": 18197,
	"./completed-tasks-color.svg": 14473,
	"./completed-tasks-gray.svg": 96789,
	"./contacts-color.svg": 78607,
	"./contacts-gray.svg": 69746,
	"./custom-campaign-color.svg": 90791,
	"./custom-campaign-gray.svg": 8296,
	"./custom-fields-color.svg": 56320,
	"./custom-fields-gray.svg": 81077,
	"./download-app-color.svg": 40497,
	"./download-app-gray.svg": 86516,
	"./download-contacts-color.svg": 88480,
	"./download-contacts-gray.svg": 46710,
	"./download-contacts-success-color.svg": 54009,
	"./download-contacts-success-gray.svg": 35423,
	"./email-broadcasts-color.svg": 26559,
	"./email-broadcasts-gray.svg": 5069,
	"./export-color.svg": 35780,
	"./export-gray.svg": 27954,
	"./fast-followup-color.svg": 54852,
	"./fast-followup-gray.svg": 43098,
	"./followup-color.svg": 46399,
	"./followup-gray.svg": 92469,
	"./form-appointment-color.svg": 11840,
	"./form-appointment-gray.svg": 12769,
	"./form-checkout-color.svg": 70043,
	"./form-checkout-gray.svg": 21747,
	"./form-internal-color.svg": 17686,
	"./form-internal-gray.svg": 37057,
	"./form-public-color.svg": 41838,
	"./form-public-gray.svg": 66763,
	"./happy-browser-color.svg": 80837,
	"./happy-browser-gray.svg": 8276,
	"./import-contacts-color.svg": 31062,
	"./import-contacts-gray.svg": 1633,
	"./leads-color.svg": 25052,
	"./leads-gray.svg": 69717,
	"./location-lookup-color.svg": 92310,
	"./location-lookup-gray.svg": 51420,
	"./messenger-color.svg": 72356,
	"./messenger-gray.svg": 32850,
	"./money-color.svg": 21805,
	"./money-gray.svg": 62907,
	"./new-contact-color.svg": 64449,
	"./new-contact-gray.svg": 4660,
	"./notes-color.svg": 65935,
	"./notes-gray.svg": 45285,
	"./oops-color.svg": 19938,
	"./oops-gray.svg": 38747,
	"./phone-number-ready-color.svg": 60096,
	"./phone-number-ready-gray.svg": 64189,
	"./pipeline-color.svg": 45766,
	"./pipeline-gray.svg": 5937,
	"./promote-color.svg": 17411,
	"./promote-gray.svg": 52231,
	"./sad-calendar-color.svg": 15433,
	"./sad-calendar-gray.svg": 88313,
	"./sales-invoice-color.svg": 37821,
	"./sales-invoice-gray.svg": 33345,
	"./sales-promo-code-color.svg": 66206,
	"./sales-promo-code-gray.svg": 76806,
	"./sales-quote-color.svg": 10921,
	"./sales-quote-gray.svg": 68761,
	"./sales-recurring-payment-color.svg": 31140,
	"./sales-recurring-payment-gray.svg": 79809,
	"./sales-upsell-color.svg": 82647,
	"./sales-upsell-gray.svg": 77272,
	"./scan-contact-color.svg": 38031,
	"./scan-contact-gray.svg": 71947,
	"./segment-color.svg": 75901,
	"./segment-gray.svg": 91423,
	"./setup-messenger-color.svg": 20986,
	"./setup-messenger-gray.svg": 37110,
	"./simple-text-gray.svg": 31729,
	"./single-messenger-color.svg": 60080,
	"./single-messenger-gray.svg": 46701,
	"./success-confetti-color.svg": 32539,
	"./success-confetti-gray.svg": 41198,
	"./success-high-five-color.svg": 84455,
	"./success-high-five-gray.svg": 58065,
	"./success-sent-color.svg": 93609,
	"./success-sent-gray.svg": 67863,
	"./success-thumbs-up-color.svg": 86479,
	"./success-thumbs-up-gray.svg": 52393,
	"./successful-payment-color.svg": 97922,
	"./successful-payment-gray.svg": 94084,
	"./tasks-color.svg": 55176,
	"./tasks-gray.svg": 53361,
	"./three-emails-color.svg": 92266,
	"./three-emails-gray.svg": 79790,
	"./untranscribable-image-color.svg": 1797,
	"./untranscribable-image-gray.svg": 35705,
	"./upload-color.svg": 71929,
	"./upload-gray.svg": 76625,
	"./voice-messenger-color.svg": 7115,
	"./voice-messenger-gray.svg": 11866
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 26453;